/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-04 15:29:50
 * @LastEditors: K
 * @LastEditTime: 2022-08-05 10:04:48
 */
/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-02 11:46:43
 * @LastEditors: K
 * @LastEditTime: 2022-08-04 15:01:20
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  getSendMessageListFn,
  getSendMessageListFnParams,
} from '../../../services/sendMessage'

//  短信推送列表
export const getSendMessageList = createAsyncThunk<
  any,
  getSendMessageListFnParams,
  RootThunkApi
>('stand/getSendMessageList', async (params, api) => {
  return sendAsync(getSendMessageListFn(params), api)
})
